var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGraphicNeueCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M139.21,208h70.536v50.045H139.21Z",
    transform: "translate(-139.21 -208)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4390",
    "data-name": "Group 4390",
    transform: "translate(-5968 -6699.953)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(5968 6699.953)",
    fill: "#e8fcff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "car",
    transform: "translate(5982.776 6723.346)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M154,253.488v2.436a2.195,2.195,0,0,1-2.165,2.165h-9.381a2.118,2.118,0,0,1-2.075-2.165c0-6.314,0-12.628.09-18.943.09-7.577,3.247-9.742,3.878-10.463h-3.788a1.388,1.388,0,0,1-1.353-1.353v-1.714c0-.722.9-1.443,1.624-1.534l6.584-.9,4.33-8.118a9.96,9.96,0,0,1,5.592-3.518,114.883,114.883,0,0,1,34.276,0,9.99,9.99,0,0,1,5.5,3.518l4.42,8.118,6.584.9c.721.09,1.624.812,1.624,1.534v1.714a1.388,1.388,0,0,1-1.353,1.353H204.51c.721.722,3.878,2.886,3.969,10.463,0,6.314.09,12.628.09,18.943a2.179,2.179,0,0,1-2.075,2.165h-9.471a2.118,2.118,0,0,1-2.075-2.165v-2.436a344.68,344.68,0,0,1-40.952,0Zm3.7-40.229a4.573,4.573,0,0,0-2.976,2.075c-1.262,2.436-2.526,4.961-3.788,7.4h47.084c-1.262-2.435-2.526-4.961-3.788-7.4a4.574,4.574,0,0,0-2.976-2.075,139.178,139.178,0,0,0-33.555,0Zm46.454,24.894c-4.33.812-8.569,1.353-12.718,2.255a6.372,6.372,0,0,0-2.345,2.526,4.243,4.243,0,0,0-.09,1.894c4.059-.631,8.118-1.262,12.087-1.984a5.459,5.459,0,0,0,3.067-2.8,3.238,3.238,0,0,0,0-1.894Zm-59.35,0c4.24.812,8.479,1.353,12.628,2.255a3.635,3.635,0,0,1,2.435,4.42c-4.059-.631-8.028-1.262-12.087-1.984a5.459,5.459,0,0,1-3.067-2.8,3.936,3.936,0,0,1,.09-1.894Z",
    transform: "translate(-139.206 -208.08)",
    fill: "#00c4de",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 7.222,
    cy: 1.667,
    rx: 7.222,
    ry: 1.667,
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 6.826, 29.94)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 7.222,
    cy: 1.667,
    rx: 7.222,
    ry: 1.667,
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 65.223, 33.159)",
    fill: "#5f5f5f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphicNeueCar);
export default __webpack_public_path__ + "static/media/icon_graphic_neue_car.dfe13366c023a12d505ccdbd9ce99e6e.svg";
export { ForwardRef as ReactComponent };